// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1GRrW","legacyBtn":"MutateMid_legacyBtn__CaNTA"};